export type Action =
  | 'list' // List items
  | 'viewDetails' // View details of an item
  | 'create' // Create a new item
  | 'update' // Update an existing item
  | 'delete' // Delete an item
  | 'abort' // Abort an in-progress item
  | 'open' // Open an item
  | 'close' // Close an item
  | 'export' // Export items
  | 'viewComments' // View item comments
  | 'manage' // Manage all items
  | 'changePassword'; // Change user password

// Define reusable action groups for better readability
export const EAction = {
  all: ['list', 'viewDetails', 'create', 'update', 'delete'],
  read: ['list', 'viewDetails'],
  write: ['create', 'update', 'delete'],
} as const satisfies Record<string, Action[]>;
